
document.addEventListener('DOMContentLoaded', function() {
  // 视频控制功能
  document.querySelectorAll('[data-video-toggle]').forEach(button => {
    button.addEventListener('click', function() {
      const videoContainer = this.closest('.video-container');
      const video = videoContainer.querySelector('video');
      
      if (video.paused) {
        video.play();
        this.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="4" width="4" height="16" fill="currentColor"/><rect x="14" y="4" width="4" height="16" fill="currentColor"/></svg>';
      } else {
        video.pause();
        this.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 5V19L19 12L8 5Z" fill="currentColor"/></svg>';
      }
    });
  });
});

